import api from './api';

// Patients and their medical aid cover. The current cover is saved with the
// patient: { ...patient, cover: { scheme_id, plan_option, membership_number,
// dependant_code, relationship, main_member } | null }.
const patientService = {
  search: (q, { inactive = false, review } = {}) =>
    api.get('/patients', { params: { q: q || undefined, include_inactive: inactive ? 1 : undefined, review } }).then((r) => r.data.patients || []),
  get: (id) => api.get(`/patients/${id}`).then((r) => r.data.patient),
  // Both resolve to { patient, warnings }. A 409 with code 'possible_duplicate' carries `matches`.
  create: (payload) => api.post('/patients', payload).then((r) => r.data),
  update: (id, payload) => api.put(`/patients/${id}`, payload).then((r) => r.data),
  setActive: (id, active) => api.post(`/patients/${id}/${active ? 'reactivate' : 'deactivate'}`).then((r) => r.data.patient),

  schemes: () => api.get('/patients/schemes').then((r) => r.data.schemes || []),
  addScheme: (name) => api.post('/patients/schemes', { name }).then((r) => r.data.scheme),
  lookupMembership: (schemeId, membershipNumber) =>
    api.get('/patients/memberships/lookup', { params: { scheme_id: schemeId, membership_number: membershipNumber } }).then((r) => r.data),
};

export default patientService;
